module.exports = __webpack_public_path__ + "static/media/employeeTrackerS.d33b9a68.png";